<template>
  <nd-dialog
    v-model="visible"
    :footer="false"
  >
    <div class="dialog-box">
      <div class="logo">
        <img src="https://static.ndmicro.com/tmd/landing/components/images/logo.png">
        <div class="close-btn" @click="closeAction">
          <img src="https://static.ndmicro.com/tmd/landing/components/images/btn_close.png">
        </div>
      </div>
      <div class="title">
        <div class="text-red">官方链接已复制到剪切板</div>
        <div class="text-black">请通过浏览器访问体验全功能</div>
      </div>
      <img class="image" src="https://static.ndmicro.com/tmd/landing/components/images/img_a.png">
      <div class="tips text-black">安装完成后，打开天美贷，立即提现</div>
      <nd-button
        @click="copyUrlLink"
        class="copy-btn"
        data-sensors-click
      >复制链接到浏览器，闪电提现
      </nd-button>
    </div>
  </nd-dialog>
</template>

<script>
import { getKey, copyToClipbord } from '@/assets/utils'
export default {
  name: 'WebClipCopyPop',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    copyUrlLink () {
      const userInfo = getKey('userInfo')
      copyToClipbord(`${window.location.href}&token=${userInfo.token}`)
      this.$message('链接已复制，通过浏览器打开', 2000)
    },
    closeAction () {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.dialog-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px 40px;
  color: #333;
  .logo {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    img {
      width: 262px;
      height: 40px;
    }
    .close-btn {
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    margin-top: 30px;
    text-align: center;
  }
  .image {
    width: 100%;
    margin-top: 27px;
  }
  .tips {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 37px;
    margin-top: 25px;
  }
  .copy-btn {
    width: 536px;
    height: 80px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 80px;
    margin-top: 20px;
  }
}
.text-red {
  color: #FF4633;
}
.text-black {
  color: #333;
}

</style>